/* eslint-disable react/require-default-props */
/* eslint-disable implicit-arrow-linebreak */
// type Props = {}

import { notification } from 'antd';
import { RootState } from 'modules/rootReducer';
import { getNotificationListApi } from 'pages/Notifications/api/NotificationApis';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { isConnectionError } from './checkAxiosError';

export const isRedirectFromOffline = (notif?: string | boolean) => {
  const isRedirect = localStorage.getItem('isRedirectFromOffline');
  localStorage.removeItem('isRedirectFromOffline');
  if (notif && isRedirect === 'true') {
    notification.success({
      message: 'Hệ thống đã kết nối lại',
      description: notif === true ? 'Bạn đã có thể truy cập các chức năng bình thường' : notif,
      duration: 10,
    });
  }
  return isRedirect === 'true';
};

const OfflineNotice = () => {
  return <div style={{ textAlign: 'center', position: 'fixed', top: 20, right: 20, zIndex: 1000, opacity: 0.8, backgroundColor: 'red', color: 'white', fontWeight: 600, padding: '8px 12px', borderRadius: '4px' }}>Offline</div>;
};

type OfflineContainerProps = {
  onlineUrl?: string;
  children: JSX.Element | JSX.Element[];
};

export default function OfflineContainer({ onlineUrl, children }: OfflineContainerProps) {
  const [isOffline, setIsOffline] = useState<boolean>(undefined);
  const loggedInUser = useSelector((state: RootState) => state.authReducer.loggedInUser);
  const history = useHistory();
  const KEY_GET_NOTIFICATIONS = 'p_SACHSO_ThongBao_NguoiDung_DanhSach';
  const { data: notificationList } = useQuery(
    KEY_GET_NOTIFICATIONS,
    () =>
      getNotificationListApi({
        UserId: loggedInUser?.id ?? 0,
        PageNum: 1,
        PageSize: 8,
      }),
    {
      onSuccess: () => {
        setIsOffline(false);
      },
      // onError: (error) => {
      //   if (isConnectionError(error)) {
      //     setIsOffline(true);
      //   } else {
      //     setIsOffline(false);
      //   }
      // },
      retry: (failureCount, error) => {
        // Check connection error on every retry attempt
        if (isConnectionError(error)) {
          setIsOffline(true);
          return true; // Continue retrying for connection errors
        }
        setIsOffline(false);
        return false; // Don't retry for non-connection errors
      },
      retryDelay: 30000, // Retry every 30 seconds
    },
  );
  useEffect(() => {
    if (isOffline === false) {
      localStorage.setItem('isRedirectFromOffline', 'true');
      history.push(onlineUrl ?? '/');
    }
  }, [isOffline, history]);
  return isOffline ? (
    <>
      <OfflineNotice />
      {children}
    </>
  ) : (
    <></>
  );
}
